(ns dre.pages.frontpage.topic-search.templates.healthcare-economics
  (:require
   [dre.i18n.views :refer [tr]]))

(def template
  {:healthcare-economics {:title [tr "Healthcare Economics"]
                          :form-sub-heading [:<>
                                             [:span [tr "Please add one or more terms for any category."]]
                                             [:span [tr "After clicking “View Results”, you can edit your question and/or search criteria."]]]
                          :forms-type :common
                          :forms [{:title [tr "Populations"] 
                                   :form-id :populations
                                   :form-type :common
                                   :required? false
                                   :top-terms-type ["C"]
                                   :operator :and
                                   :examples [{:pill/type :term
                                               :pill/query "SUFus"
                                               :pill/label "Acute Myeloid Leukemia"}
                                              {:pill/type :term
                                               :pill/query "SUBAB"
                                               :pill/label "Asthma"}
                                              {:pill/type :term
                                               :pill/query "SUElw"
                                               :pill/label "Heart Disease"}
                                              {:pill/type :term
                                               :pill/query "SUcB"
                                               :pill/label "Elderly"}]}
                                  {:title [tr "Interventions/Comparators"] 
                                   :form-id :intervention
                                   :form-type :common
                                   :required? false
                                   :top-terms-type ["I"]
                                   :operator :or
                                   :examples [{:pill/type :senses
                                               :pill/query "SUyz"
                                               :pill/other-senses (list "SUBESP"),
                                               :pill/excluded-senses (list),
                                               :pill/label "Monoclonal Antibody"}
                                              {:pill/type :term
                                               :pill/query "SUClep"
                                               :pill/label "Gemtuzumab"}
                                              {:pill/type :term
                                               :pill/query "SUDspt"
                                               :pill/label "Mepolizumab"}
                                              {:pill/type :term
                                               :pill/query "SUDbK"
                                               :pill/label "Enalapril"}]}
                                  {:title [tr "Economic Outcomes"]
                                   :form-id :economic-outcomes
                                   :form-type :common
                                   :required? false
                                   :top-terms-type nil
                                   :top-terms-hardcoded-fn (fn [search-query-template]
                                                             [{:pill/type :term
                                                               :pill/query "SUE4a"
                                                               :pill/label "Hospitalization"}
                                                              {:pill/type :senses
                                                               :pill/query "SU16N"
                                                               :pill/label "Cost"
                                                               :pill/other-senses (list "SUCfL")
                                                               :pill/excluded-senses (list)}
                                                              {:pill/type :term
                                                               :pill/query "S0q46"
                                                               :pill/label "Emergency room"}
                                                              {:pill/type :term
                                                               :pill/query "SUFsI"
                                                               :pill/label "Length of Stay"}
                                                              {:pill/type :term
                                                               :pill/query "SUNS"
                                                               :pill/label "Absenteeism"}
                                                              {:pill/type :term
                                                               :pill/query "SUCfG"
                                                               :pill/label "cost-effectiveness"}
                                                              {:pill/type :term
                                                               :pill/query "SURIA9"
                                                               :pill/label "Readmission"}
                                                              {:pill/type :term
                                                               :pill/query "SUHTi"
                                                               :pill/label "Outpatients"}
                                                              {:pill/type :term
                                                               :pill/query "SUUx8u"
                                                               :pill/label "Healthcare Utilization"}
                                                              {:pill/type :term
                                                               :pill/query "SUFTN"
                                                               :pill/label "Intensive Care Unit"}])
                                   :operator :or
                                   :examples [{:pill/type :term
                                               :pill/query "SUE4a"
                                               :pill/label "Hospitalization"}
                                              {:pill/type :senses
                                               :pill/query "SU16N"
                                               :pill/other-senses (list "SUCfL"),
                                               :pill/excluded-senses (list),
                                               :pill/label "Cost"}
                                              {:pill/type :term
                                               :pill/query "S0q46"
                                               :pill/label "Emergency room"}
                                              {:pill/type :term
                                               :pill/query "SUFsI"
                                               :pill/label "Length of Stay"}]}]
                          :review-query-render-fn (fn [items search-query-template]
                                                    [:span.text (str " What is the economic impact of ") (:intervention items)
                                                     " on " (:economic-outcomes items) " in "
                                                     (:populations items)
                                                     " population(s)?"])
                          :default-search-query-template :accuracy
                          :search-query-templates {:accuracy {:query/pill
                                                              {:pill/type "boost"
                                                               :pill/pills
                                                               [{:pill/type "and"
                                                                 :pill/pills
                                                                 [{:pill/type "tag"
                                                                   :pill/query "predicted/healthcare_utilization_postfilter"
                                                                   :pill/label "Healthcare Economics"}
                                                                  {:template-type :populations
                                                                   :pill/type "sentence-tag"
                                                                   :pill/query "title-or-keywords"}
                                                                  {:template-type :intervention
                                                                   :pill/type "sentence-tag"
                                                                   :pill/query "title-or-abstract-or-keywords"}
                                                                  {:template-type :economic-outcomes
                                                                   :pill/type "sentence-tag"
                                                                   :pill/query "title-or-abstract-or-keywords"}]}
                                                                {:template-type :economic-outcomes
                                                                 :pill/type "sentence-tag"
                                                                 :pill/query "title-or-abstract"}
                                                                {:template-type :populations
                                                                 :pill/type "sentence-tag"
                                                                 :pill/query "title"}
                                                                {:template-type :intervention
                                                                 :pill/type "sentence-tag"
                                                                 :pill/query "title"}]}
                                                              :response/filter
                                                              {:search/count true :search/count-1w true :search/count-6m true}}}}})